import type { Bounds, EntityId, Vec2 } from "@core/types";
import { asEntityId } from "@core/types";
import {
  PLAYER_BOUNDS as _PLAYER_BOUNDS,
  PLAYER_SPEED_GLOW as _PLAYER_SPEED_GLOW,
  PLAYER_SPEED_NORMAL as _PLAYER_SPEED_NORMAL,
} from "@data/balance";

/** Балансовые константы — реэкспорт из @data/balance для удобства. */
export const PLAYER_SPEED_NORMAL: number = _PLAYER_SPEED_NORMAL;
export const PLAYER_SPEED_GLOW: number = _PLAYER_SPEED_GLOW;
export const PLAYER_BOUNDS: Bounds = _PLAYER_BOUNDS;

/** Игровая сущность Boo. */
export interface Player {
  readonly id: EntityId;
  position: Vec2;
  facing: "left" | "right";
  isMoving: boolean;
}

/** Создаёт нового игрока с заданной начальной позицией. */
export const createPlayer = (initial: Vec2): Player => ({
  id: asEntityId("player"),
  position: { ...initial },
  facing: "right",
  isMoving: false,
});
